let likes = (function ($, options) {

  let buttons;

  let self = {};
  self.settings = {};
  self.ui = {};

  function init() {
    if (bindUI()) {
      watchUI();
    }
  }

  function bindUI() {
    buttons = document.querySelectorAll('.like-input');
    return buttons;
  }

  function watchUI() {
    buttons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        incrementStoredLikes(button.dataset.id);
        incrementShownLikes(button.dataset.id);
      });
    });
  }

  function incrementShownLikes(id) {
    let buttons = document.querySelectorAll("[data-id='" + id + "']");
    buttons.forEach(function (button) {
      let countSpan = button.querySelector('.like-count');
      let oldCount = parseInt(countSpan.innerHTML);
      countSpan.innerHTML = (oldCount + 1);

    });
    //let oldCount = parseInt(buttonSpans.innerHTML);
    //buttonSpans.innerHTML = oldCount + 1;
  }

  function incrementStoredLikes(id) {
    let headers = new Headers({
      'Content-Type': 'application/json',
      'X-WP-Nonce': wpApiSettings.nonce
    });

    if (wpApiSettings.nonce === 1) {
      headers.append('Authorization', 'Basic ' + window.btoa('puzzel-hub' + ":" + 'xOU3423ur'));
    }

    return fetch(
      document.location.origin + '/wp-json/likes/v1/increment',
      {
        method: 'POST',
        body: JSON.stringify({
          id: id
        }),
        headers: headers
      }
    );
  }

  init();

  return self;

}(jQuery, {}));